import type { TRuleWithTheme } from '@/styles/theme';

export const field: TRuleWithTheme = () => ({
    '&.ant-form-item': {
        width: '100%',
    },
});

export const nameInput: TRuleWithTheme = () => ({
    '&.ant-input': {
        paddingTop: '0.625rem',
        paddingBottom: '0.625rem',
        paddingRight: '0.5rem',

        fontSize: '0.875rem',
        lineHeight: '1.125rem',
    },
});
